var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-grid-badge"},[_c('div',{staticClass:"grid-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"grid-number",style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }